import { Spinner } from './ui/spinner';

export function PageLoader() {
	return (
		<div className="flex flex-col items-center justify-center h-svh">
			<Spinner className="size-50 text-muted-foreground" />
		</div>
	);
}
